import React from 'react';

import { isNonEmptyString, isDefined, isArray } from 'Core/Utils/TypeUtils';
import { unique, equals } from 'Core/Utils/ObjectUtils';
import { openUrl } from 'Core/Utils/DomUtils';
import DataTable from 'Core/Components/DataTable';
import TagFilter from 'Core/Components/TagFilter';

class RoleList extends React.Component {
  constructor (props) {
    super(props);

    this.state = { filteredRoles: props.roles.filter(({ hidden }) => !hidden) };
    this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
  }

  componentWillReceiveProps (newProps) {
    if (!equals(newProps.roles, this.props.roles)) {
      this.setState({
        filteredRoles: newProps.roles
      });
    }
  }

  handleFilterChange (filteredRoles) {
    this.setState({ filteredRoles });
  }

  render () {
    const { roles: allRoles, groupBy, filterBy } = this.props;
    const { filteredRoles } = this.state;
    const roles = allRoles.filter(({ hidden }) => !hidden);

    const shouldFilterBy = isNonEmptyString(filterBy)
      && roles.some(role => Object.keys(role).includes(filterBy));
    const shouldGroupBy = isNonEmptyString(groupBy)
      && roles.some(role => Object.keys(role).includes(groupBy));

    const columns = [
      {
        name: 'Position',
        columnStyle: { width: shouldGroupBy ? '35%' : '25%' },
        renderCell: role => role.position
      },
      (shouldGroupBy ? null : {
        title: 'Company',
        columnStyle: { width: '25%' },
        renderCell: role => role.company
      }),
      {
        name: 'Category',
        columnStyle: { width: shouldGroupBy ? '25%' : '25%' },
        renderCell: role => role.category
      },
      {
        name: 'Season',
        columnStyle: { width: '15%' },
        renderCell: role => role.season
      },
      {
        name: '',
        columnStyle: { width: '15%' },
        className: 'text-right',
        renderCell: role => role.filled
          ? <i>Filled</i>
          : role.link
            ? <a href={role.link} target="_blank" children={role.linkLabel || 'Learn More'} />
            : role.linkLabel
              ? <span children={role.linkLabel} />
              : null
      }
    ].filter(c => c);

    const grouped = !shouldGroupBy ? null : filteredRoles.reduce((output, role, roleIndex) => {
      if (isDefined(role[groupBy])) {
        const groupName = role[groupBy];
        output[groupName] = isArray(output[groupName]) ? [ ...output[groupName], role ] : [ role ];
      } else {
        output['(other)'] = isArray(output['(other)']) ? [...output['(other)'], role] : [ role ];
      }

      return output;
    }, {});

    const filters = unique(
      roles
        .filter(role => isNonEmptyString(role[filterBy]))
        .map(role => role[filterBy].trim())
    );

    return (
      <div className="role-list-container">
        {!shouldFilterBy ? null : (
          <TagFilter
            list={roles.map(role => ({ ...role, tags: [role.category] }))}
            single={true}
            filters={filters}
            onFilter={this.handleFilterChange}
          />
        )}
        {!shouldGroupBy
          ? <DataTable
              className="role-list"
              hideHeadings={true}
              columns={columns}
              rows={filteredRoles}
            />
          : Object.keys(grouped).map(groupName => (
              <div className="role-list-group" key={groupName}>
                <h2 className="text-upper display">{groupName}</h2>
                <DataTable
                  className="role-list"
                  hideHeadings={true}
                  rowClass={row => row.filled ? 'row-filled' : row.link ? 'row-available' : 'row-inert'}
                  columns={columns}
                  rows={grouped[groupName]}
                  onRowClick={row => !row.hidden && !row.filled && row.link ? openUrl(row.link) : null}
                />
              </div>
            ))
        }
      </div>
    );
  }
}

export default RoleList;



// WEBPACK FOOTER //
// ./client/Core/Components/RoleList.jsx